<template>
        <div class="wrapper">
        <v-layout>
            <v-main style="">
                <v-container>
                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                                        <h4 class="
                                        text-h6
                                        text-md-h6
                                        text-lg-h5
                                        text-xl-h5
                                        text-truncate">
                                            License
                                        </h4>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">
                            This web application and its content are licensed under the Creative Commons Attribution-ShareAlike 4.0
                            International License (CC BY-SA 4.0).
                            <br /><br />

                            1) You are free to:<br /><br />

                            <ul>
                                <li><b>Share:</b> Copy and redistribute the material in any medium or format.</li>
                                <li><b>Adapt:</b> Remix, transform, and build upon the material for any purpose, even commercially.</li>
                            </ul>

                            2) Under the following terms:<br /><br />

                            <ul>
                                <li><b>Attribution:</b> You must give appropriate credit, provide a link to the license, and indicate
                                if changes were made. You may do so in any reasonable manner, but not in any way that
                                suggests the licensor endorses you or your use.</li>
                                <li><b>ShareAlike:</b> If you remix, transform, or build upon the material, you must distribute
                                your contributions under the same license as the original.</li>
                            </ul>

                            No additional restrictions: You may not apply legal terms or technological measures that
                            legally restrict others from doing anything the license permits.<br /><br />

                            Disclaimer:<br />
                            This license does not apply to:<br/>

                                Third-party content included in the web application, which may be subject to other licenses or permissions.<br/>
                                User-uploaded data, which remains the property of the respective user or third-party owner.<br /><br/>

                            For the full legal text of the
                            <a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en">
                            Creative Commons Attribution-ShareAlike 4.0 International License
                            </a>.
                        </v-col>
                    </v-row>
                    <v-row>
                            <v-col align="center">
                                <img src="@/assets/creative-commons-783531_960_720.png" width="100" />
                            </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<style>
</style>